var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUniversityAbroad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8234_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4841 0.339111L55.978 11.3367V15.0025H52.3122C52.3122 15.4989 52.1165 15.9285 51.7251 16.2913C51.3337 16.6541 50.8706 16.8354 50.336 16.8354H6.63221C6.09761 16.8354 5.6346 16.6541 5.2432 16.2913C4.85179 15.9285 4.65609 15.4989 4.65609 15.0025H0.990234V11.3367L28.4841 0.339111ZM8.32194 18.6684H15.6536V40.6635H19.3195V18.6684H26.6512V40.6635H30.3171V18.6684H37.6488V40.6635H41.3146V18.6684H48.6463V40.6635H50.336C50.8706 40.6635 51.3337 40.8449 51.7251 41.2076C52.1165 41.5704 52.3122 42 52.3122 42.4964V44.3293H4.65609V42.4964C4.65609 42 4.85179 41.5704 5.2432 41.2076C5.6346 40.8449 6.09761 40.6635 6.63221 40.6635H8.32194V18.6684ZM54.0019 46.1623C54.5365 46.1623 54.9995 46.3436 55.3909 46.7064C55.7823 47.0692 55.978 47.4988 55.978 47.9952V51.661H0.990234V47.9952C0.990234 47.4988 1.18594 47.0692 1.57734 46.7064C1.96875 46.3436 2.43175 46.1623 2.96636 46.1623H54.0019Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8234_6090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 51.3219,
    fill: "white",
    transform: "translate(0.982422 0.339111)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUniversityAbroad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/University_abroad.54cd103cbfa265fde766011aef7b6ce7.svg";